"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var useInit = function (customOverlay) {
    React.useEffect(function () { return function () { return customOverlay.setMap(null); }; }, []);
};
var usePosition = function (customOverlay, position) {
    React.useEffect(function () {
        var latlng = new kakao.maps.LatLng(position.lat, position.lng);
        customOverlay.setPosition(latlng);
    }, [position]);
};
var useRange = function (customOverlay, range) {
    React.useEffect(function () { customOverlay.setRange(range); }, [range]);
};
var useAltitude = function (customOverlay, altitude) {
    React.useEffect(function () { customOverlay.setAltitude(altitude); }, [altitude]);
};
var useZIndex = function (customOverlay, zIndex) {
    React.useEffect(function () { customOverlay.setZIndex(zIndex); }, [zIndex]);
};
exports.default = {
    useInit: useInit,
    useRange: useRange,
    useZIndex: useZIndex,
    usePosition: usePosition,
    useAltitude: useAltitude,
};
